import React, { forwardRef, useImperativeHandle } from 'react';
import { TitlelessDialogBox, useDialog } from '../../../comps/dialog';
import { Button, DialogTitle } from '@headlessui/react'
import { ls } from '../../../locale';
import btnStyles from '../../../styles/btn.module.scss';
import SeatBenefit from '../../SeatsPage/SeatBenefit';

export type MessageBoxHandler = {
  show(): Promise<boolean>
}

export const MessageBox = forwardRef<MessageBoxHandler>((props, ref) => {

  const dialog = useDialog();

  function show(): Promise<boolean> {
    return dialog.show()
  }

  useImperativeHandle(ref, () => ({ show }))

  return (
    <TitlelessDialogBox open={dialog.open} onClose={dialog.close} panelClass='tw-max-w-lg'>
      <DialogTitle as="div" className="tw-flex tw-justify-center tw-items-center tw-p-2 sa-bg-lightblue tw-rounded-t-md tw-text-white tw-font-bold tw-text-lg">
        {ls.t('MessageBox.Title.Alert')}
      </DialogTitle>
      <div className="tw-mt-4 tw-px-4">
        <p className="tw-text-lg tw-text-center">{ls.t('SeatPage.RandomSeat.Confirmation')}</p>
        <SeatBenefit />
      </div>
      <div className="tw-grid tw-grid-flow-col tw-justify-end tw-gap-2 tw-mt-2 tw-p-4">
        <Button className={btnStyles.outline} onClick={() => dialog.close(false)}>{ls.t('SeatPage.SelectSeat')}</Button>
        <Button className={btnStyles.secondary} onClick={() => dialog.close(true)}>{ls.t('Button.Continue')}</Button>
      </div>
    </TitlelessDialogBox>
  )
})